import { GenericModelApi } from "./GenericModelApi";
import { ApiSchema, FetchResponse } from "./ApiClient";
import { ReceivedEmailFormData, ReceivedEmailRelatedAttributes } from "@/formTypes/ReceivedEmailDataType";
import { ReceivedEmailFormDataKeys } from "@/generated/ReceivedEmailFormDataKeys";

export type ReceivedEmailDataType = Partial<ApiSchema["ReceivedEmail"]["type"] & ReceivedEmailFormData>;

class Api extends GenericModelApi<"ReceivedEmail", ReceivedEmailDataType> {

    async fetchAll(filters: any = {}, token?: string, limit: number = 20): Promise<FetchResponse<ReceivedEmailDataType>> {
        const selectionSet = [
            ...ReceivedEmailFormDataKeys.filter(k => !ReceivedEmailRelatedAttributes.includes(k)),
        ]

        return super.fetchAll(filters, token, limit, selectionSet);
    }
}
const api = new Api("ReceivedEmail", "fecha", "DESC")
export const ReceivedEmailApi = api